export class ElectrodePastePara {
    constructor({
        id = ``,
        day = ``,
        time = ``,
        locName = ``,
        locId = ``,
        furnaceNumber = ``,
        additionA = ``,
        additionB = ``,
        additionC = ``,
        electrodeNumberA = ``,
        electrodeNumberB = ``,
        electrodeNumberC = ``,
        electrodeDownA = ``,
        electrodeDownB = ``,
        electrodeDownC = ``,
        pasteTempA = ``,
        pasteTempB = ``,
        pasteTempC = ``,
        liquidPasteA = ``,
        liquidPasteB = ``,
        liquidPasteC = ``,
        solidPasteA = ``,
        solidPasteB = ``,
        solidPasteC = ``,
        eastOffset = ``,
        southOffset = ``,
        westOffset = ``,
        northOffset = ``,
        eastAdjust = ``,
        southAdjust = ``,
        westAdjust = ``,
        northAdjust = ``,
        remark = ``,
        cylinderHeight = ``,
    }={}){
        this.id = id;
        this.day = day;
        this.time = time;
        this.locName = locName;
        this.locId = locId;
        this.furnaceNumber = furnaceNumber;
        this.additionA = additionA;
        this.additionB = additionB;
        this.additionC = additionC;
        this.electrodeNumberA = electrodeNumberA;
        this.electrodeNumberB = electrodeNumberB;
        this.electrodeNumberC = electrodeNumberC;
        this.electrodeDownA = electrodeDownA;
        this.electrodeDownB = electrodeDownB;
        this.electrodeDownC = electrodeDownC;
        this.pasteTempA = pasteTempA;
        this.pasteTempB = pasteTempB;
        this.pasteTempC = pasteTempC;
        this.liquidPasteA = liquidPasteA;
        this.liquidPasteB = liquidPasteB;
        this.liquidPasteC = liquidPasteC;
        this.solidPasteA = solidPasteA;
        this.solidPasteB = solidPasteB;
        this.solidPasteC = solidPasteC;
        this.eastOffset = eastOffset;
        this.southOffset = southOffset;
        this.westOffset = westOffset;
        this.northOffset = northOffset;
        this.eastAdjust = eastAdjust;
        this.southAdjust = southAdjust;
        this.westAdjust = westAdjust;
        this.northAdjust = northAdjust;
        this.remark = remark;
        this.cylinderHeight = cylinderHeight;
    }
}

export function gridFields(){
    return Object.freeze([
        {
            key: 'day',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
          key: 'time',
          label: 'lbl.basic.datetime',
          sortable: true,
          form: {
            type: 'timepicker'
          }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
            key: 'furnaceNumber',
            label: 'lbl.basic.furnaceName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'additionA',
          label: 'lbl.fm.additionA',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'additionB',
          label: 'lbl.fm.additionB',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'additionC',
          label: 'lbl.fm.additionC',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electrodeNumberA',
          label: 'lbl.fm.electrodeNumberA',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electrodeNumberB',
          label: 'lbl.fm.electrodeNumberB',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electrodeNumberC',
          label: 'lbl.fm.electrodeNumberC',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electrodeDownA',
          label: 'lbl.fm.electrodeDownA',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electrodeDownB',
          label: 'lbl.fm.electrodeDownB',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electrodeDownC',
          label: 'lbl.fm.electrodeDownC',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pasteTempA',
          label: 'lbl.fm.pasteTempA',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pasteTempB',
          label: 'lbl.fm.pasteTempB',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pasteTempC',
          label: 'lbl.fm.pasteTempC',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'liquidPasteA',
          label: 'lbl.fm.liquidPasteA',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'liquidPasteB',
          label: 'lbl.fm.liquidPasteB',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'liquidPasteC',
          label: 'lbl.fm.liquidPasteC',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'solidPasteA',
          label: 'lbl.fm.solidPasteA',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'solidPasteB',
          label: 'lbl.fm.solidPasteB',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'solidPasteC',
          label: 'lbl.fm.solidPasteC',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'eastOffset',
          label: 'lbl.fm.eastOffset',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'southOffset',
          label: 'lbl.fm.southOffset',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'westOffset',
          label: 'lbl.fm.westOffset',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'northOffset',
          label: 'lbl.fm.northOffset',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'eastAdjust',
          label: 'lbl.fm.eastAdjust',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'southAdjust',
          label: 'lbl.fm.southAdjust',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'westAdjust',
          label: 'lbl.fm.westAdjust',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'northAdjust',
          label: 'lbl.fm.northAdjust',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'cylinderHeight',
          label: 'lbl.fm.cylinderHeight',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'remark',
          label: 'lbl.fm.remark',
          sortable: true,
          form: {
            type: 'input'
          }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new ElectrodePastePara()).map(i => 'entity.'+i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.furnaceNumberFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter' : '',
    'endTimeFilter' : '',
    'furnaceNumberFilter' : 'default',
    'locNameFilter' : 'default',
};